// apps/client/src/services/notifications.service.ts

import { api } from "../lib/api";

export interface NotificationItem {
  id: string;
  userId: string;
  title: string;
  message: string;
  type: "info" | "warning" | "error" | "success";
  entityType: string | null;
  entityId: string | null;
  isRead: boolean;
  createdAt: string;
}

interface PaginatedResponse<T> {
  success: boolean;
  data: T[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

export const notificationsService = {
  // ─── Day 18 (preserved) ──────────────────────────────────────────────────
  async list(
    page = 1,
    limit = 20,
  ): Promise<PaginatedResponse<NotificationItem>> {
    const res = await api.get(`/notifications?page=${page}&limit=${limit}`);
    return res.data;
  },

  async markRead(id: string): Promise<{ success: boolean }> {
    const res = await api.put(`/notifications/${id}/read`);
    return res.data;
  },

  async markAllRead(): Promise<{ success: boolean }> {
    const res = await api.put("/notifications/read-all");
    return res.data;
  },

  // ─── Day 46 addition ─────────────────────────────────────────────────────
  async getUnreadCount(): Promise<number> {
    const res = await api.get("/notifications/unread-count");
    return res.data?.data?.count ?? 0;
  },
};

// Day 46 complete
